import React, { Fragment, useState, useEffect, useContext } from "react";
import { Dropdown, Menu } from "antd";
import Avatar from "react-avatar";
import { colors } from "../constants/defaultKeys";
import { clear } from "../helpers/localStorage";
import { getUserDetails } from "../helpers/utility";
import { Link, useHistory } from "react-router-dom";

const UserAvatar = () => {
  const history = useHistory();
  const [user, setUser] = useState(null);
  const handleClick = () => {
    history.push("/");
    clear();
  };

  useEffect(() => {
    let userDetails = getUserDetails();
    setUser(userDetails && userDetails);
  }, []);

  const menu = (
    <Menu>
      <Menu.Item key="0">
        {/* <Link onClick={() => history.push("/myprofile")}>My Profile</Link> */}
        <Link to="/myprofile">My Profile</Link>
      </Menu.Item>
      <Menu.Item key="1">
        <div onClick={handleClick}>Logout</div>
      </Menu.Item>
    </Menu>
  );

  return (
    <Fragment>
      <Dropdown overlay={menu} trigger={["click"]}>
        <Avatar
          className="memu-avatar"
          color={user && colors[user.user_id % 24]}
          round={true}
          name={user && user.first_name}
          size="40px"
        />
      </Dropdown>
    </Fragment>
  );
};

export default UserAvatar;
